<template>
  <div class="flex flex-wrap gap-2" v-if="!claimApprovalRequired && claimOpen">
    <SecondaryButton v-if="claimWaitingForInvoice" @click="$emit('open-invoice-upload')">
      Ajouter la facture
    </SecondaryButton>
    <SecondaryButton v-if="showVoucherCreate" @click="generateVoucher">
      Générer un bon d'achat et l'envoyer au client
    </SecondaryButton>
    <SecondaryButton v-if="claimWaitingForQuotation" @click="$emit('open-quotation-upload')">
      Ajouter le devis de réparation
    </SecondaryButton>
    <SecondaryButton v-if="deductiblePaymentRequired" @click="copyPaymentUrl">
      Copier le lien de paiement de la franchise
    </SecondaryButton>
    <SecondaryButton v-if="finalSettlementPaymentRequired" @click="copyPaymentUrl">
      Copier le lien de paiement du solde tout compte
    </SecondaryButton>
    <SecondaryButton v-if="finalSettlementAndDeductiblePaymentRequired" @click="copyPaymentUrl">
      Copier le lien de paiement du solde tout compte et de la franchise
    </SecondaryButton>
    <template v-if="claimWaitingForCustomerIban">
      <SecondaryButton v-if="customerIban" data-test="confirm-customer-iban" :loading="confirming" @click="confirmIban">
        {{ t("confirm_customer_iban", { iban: maskIban(customerIban.value) }) }}
      </SecondaryButton>
      <SecondaryButton data-test="upload-customer-iban" @click="$emit('open-iban-upload')">
        {{ customerIban ? t("change_customer_iban") : t("provide_customer_iban") }}
      </SecondaryButton>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { SecondaryButton, maskIban } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  components: {
    SecondaryButton,
  },

  emits: ["open-quotation-upload", "open-invoice-upload", "open-iban-upload"],

  setup() {
    const { t } = useI18n();
    return { t, maskIban };
  },

  data() {
    return { confirming: false };
  },

  computed: {
    ...mapState("claims", ["currentClaim"]),
    ...mapGetters("claims", [
      "claimApprovalRequired",
      "claimOpen",
      "claimWaitingForQuotation",
      "claimWaitingForInvoice",
      "showVoucherCreate",
      "deductiblePaymentRequired",
      "finalSettlementPaymentRequired",
      "finalSettlementAndDeductiblePaymentRequired",
      "claimWaitingForCustomerIban",
    ]),
    customerIban() {
      return this.currentClaim?.customer?.iban;
    },
  },

  methods: {
    ...mapActions("claims", ["generateVoucher", "getPaymentUrl"]),
    ...mapActions("notifications", ["notify"]),
    ...mapActions("iban", ["confirmCustomerIban"]),

    async confirmIban() {
      this.confirming = true;
      try {
        const response = await this.confirmCustomerIban({ customerId: this.currentClaim.customer.id });
        if (!response?.success) return;

        this.notify({ category: "simple", type: "success", title: this.t("customer_iban_confirmed") });
      } finally {
        this.confirming = false;
      }
    },

    async copyPaymentUrl() {
      const response = await this.getPaymentUrl();
      if (response?.success) this.copyToClipboard(response.data.url);
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.notify({
          category: "simple",
          type: "success",
          title: "Link copied to clipboard!",
        });
      });
    },
  },
};
</script>

<i18n src="./ClaimWorkflowActions.i18n.json"></i18n>
